module.exports = __webpack_public_path__ + "static/down-arrow.png";